import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { post, put } from "~/Services";
import { eramanApiURL } from "~/Utils";
import { fields } from "../constants";
import { useEdmMailerDocumentDetails } from "./Newsletter.hook";

export const AddNewsLetter = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const params = new URLSearchParams(search);
  const searchValue = params.get("createMail"); // Replace "key" with the parameter name

  console.log("search", searchValue);
  const { openToast } = useNotification();
  const [user] = useLocalStorage("user", null);

  const {
    data: editEdmMailer,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditEdmMailer,
  } = useEdmMailerDocumentDetails(query.get("editId") || "");

  const {
    data: edmMailerById,
    isLoading: isLoadingEdmMailer,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditEdmMailer();
    }
  }, [query.get("editId"), query.get("id")]);

  const userFormConfig: FormConfig = {
    initialValues: {
      title: edmMailerById
        ? decodeHTML(edmMailerById.payload.title)
        : editEdmMailer
          ? decodeHTML(editEdmMailer.title)
          : "",
      description: edmMailerById
        ? decodeHTML(edmMailerById.payload.description)
        : editEdmMailer
          ? decodeHTML(editEdmMailer.description)
          : "",
      fromName: edmMailerById
        ? decodeHTML(edmMailerById.payload.fromName)
        : editEdmMailer
          ? decodeHTML(editEdmMailer.fromName)
          : "",
      fromMail: edmMailerById
        ? decodeHTML(edmMailerById.payload.fromMail)
        : editEdmMailer
          ? decodeHTML(editEdmMailer.fromMail)
          : "",
      subject: edmMailerById
        ? decodeHTML(edmMailerById.payload.subject)
        : editEdmMailer
          ? decodeHTML(editEdmMailer.subject)
          : "",
      body: edmMailerById
        ? decodeHTML(edmMailerById.payload.body)
        : editEdmMailer
          ? decodeHTML(editEdmMailer.body)
          : "",
      updatedBy: user?.email,
      // header: edmMailerById
      //   ? decodeHTML(edmMailerById.payload.header)
      //   : editEdmMailer
      //     ? decodeHTML(editEdmMailer.header)
      //     : "",
      // footer: edmMailerById
      //   ? decodeHTML(edmMailerById.payload.footer)
      //   : editEdmMailer
      //     ? decodeHTML(editEdmMailer.footer)
      //     : "",
    },
    fields: fields.newsLetter,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("formdata", data);
    let imageKeys: any = [
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const payload = {
      action: action,
      method: method,
      module: "Configuration",
      subModule: "newsLetter",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      type: "DEDICATED",
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        id: editEdmMailer?.id || edmMailerById?.payload?.id,
        ...data,
        published: true,
        type: "NewsLetter",
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingEdmMailer}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add"} Newsletter  Mailer`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingEdmMailer || drilldownLoading}
        config={userFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update" ? `${eramanApiURL}/admin/mails/update` : `${eramanApiURL}/admin/mails/create`}`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PUT" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
